import * as ACTION_TYPES from './types';

const initialState = {
  status: {
    loadPayers: -1,
  },
  payers: [],
};

export default function reducer(state = initialState, action) {
  const { type, error, payload } = action;

  switch (type) {
    case ACTION_TYPES.INVOICE_PAYERS_GET_REQUESTED:
      return {
        ...state,
        status: {
          ...state.status,
          loadPayers: 0,
        },
        error: null,
      };

    case ACTION_TYPES.INVOICE_PAYERS_GET_SUCCEED:
      return {
        ...state,
        status: {
          ...state.status,
          loadPayers: 1,
        },
        payers: payload.data,
      };

    case ACTION_TYPES.INVOICE_PAYERS_GET_FAILED:
      return {
        ...state,
        status: {
          ...state.status,
          loadPayers: 2,
        },
        error,
      };
    default:
      return state;
  }
}
